import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { selectLocaleDict } from 'features/locale/selectors'

import logoImg from 'shared/img/logo.png'

import './NotifyContainer.scss'

interface INotifyContainerProps {
  title: string
  value: string
  currency: string
  callback: () => void
  hideTemporarily: () => void
}

const b = block('notify-container')

const NotifyContainer: React.FC<INotifyContainerProps> = ({ title, value, callback, hideTemporarily, currency }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  return (
    <div className={b()}>
      <div className={b('background')} onClick={hideTemporarily} />
      <div className={b('card')}>
        <div className={b('card-surface')}>
          <div className={b('heading')}>
            <span className={b('title')}>{title}</span>
          </div>
          <div className={b('body')}>
            <div className={b('you-got')}>{locale.youGot}</div>
            <div className={b('amount-block')}>
              <div className={b('value')}>{value.trim()}</div>
              <div className={b('currency')}>{currency}</div>
            </div>
          </div>
          <div className={b('actions')}>
            <button type="button" className={b('submit')} onClick={callback}>
              {locale.notifyOk}
            </button>
          </div>
          <div className={b('divider')} />
          <div className={b('logo-wrapper')}>
            <div className={b('logo-glow')} aria-hidden />
            <img src={logoImg} alt="" className={b('logo')} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotifyContainer
